module.exports = __webpack_public_path__ + "static/media/nuestroblog_consumodetrigopercapita.23ac0bfc.png";